<template>
<div>
    <base-header v-once pageName="참여 설문" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
      <div class="search">
        <base-selectbox selectName="년도 선택"
            :default="''"
            v-on:selectSearch="year"
            :options="makeSelect(2021)"
        ></base-selectbox>
      </div>

      <ul class="survey-list" v-if="this.list.length > 0">
          <li v-for="(item,index) in list" v-bind:key="item.srvySqno">
              <div>
                  <em :class="item.status === 'ing' ? 'ing' : 'fin' ">{{item.status === 'ing' ? "진행중" : "종료"}}</em>
                  <p>{{item.titl}}</p>
                  <figure @click="openView(index)" :class="(item.status === 'ing'  && item.comStatus === 'non') ?  'parti' : (item.status === 'fin'  && item.comStatus === 'non') ?  'none' : 'clear' ">
                      {{(item.status === 'ing'  && item.comStatus === 'non') ?  "참여하기" : (item.status === 'fin'  && item.comStatus === 'non') ?  "미참여" : "참여 완료" }}
                  </figure>
              </div>
              <dl>
                  <dt>대상</dt>
                  <dd>{{item.pstnTyp}}</dd>
                  <dt>진행일</dt>
                  <dd>{{item.sttTime}} ~ {{item.endTime}}</dd>

              </dl>
          </li>
      </ul>

      <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
          <div slot="no-more"></div>
          <div slot="no-results">
            <ul class="survey-list">
              <li class="dataNone">검색된 설문조사가 없습니다.</li>
            </ul>
          </div>
      </infinite-loading>
      <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
      <!--// 2026.09.18 챗봇 버튼-->
    </section>
</div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "SurveyList",
  components: {
    InfiniteLoading,

  },
  data() {
      return{
          loginGbn : this.$store.getters.loginGbn, //로그인구분
          srvySqno : 0,
          active : null,
          list:[],
          tot:0,
          offset: 0,     //현재 가지고있는 갯수
          size : 10,    //한번에 가져오는 수
          divCd: 'MS00' ,
          searchYear : ''
      };
  },


  methods: {


    infiniteHandler : function($state){
			console.log('SCROLL')
      var that = this;
      var parameters = {
        offset: this.offset,
        size: this.size,
        divCd : this.divCd,
        searchYear : this.searchYear
      };
      this.$api.mypage
        .list(parameters)
        .then(function(data) {
          that.tot = data.totCnt;  // API에서 가져온 총 카운트
          var list = data.list;   //API에서 가져온 리스트
          if (list.length) {
            that.list = that.list.concat(list);
            $state.loaded();
            that.offset += that.size;

            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    makeSelect: function(openYr){ //년도 셀렉트박스 생성

        var selectDate = new Date();
        var selectYear = selectDate.getFullYear();
        var yearList = []; //날짜
        for (var i = 0 ; i <= selectYear - openYr ; i++) {
            var option = {text : selectYear-i , value : selectYear-i  }
            yearList.push(option);
        }
        return yearList;
    },

    year: function(val) {
      this.searchYear = val;
			this.totalCnt = 0
			this.offset = 0
			this.size = 10
			this.list = []
			this.$refs.InfiniteLoading.stateChanger.reset();
    },
    openView : function(index){
      var item = this.list[index];
      var status = item.status;
      var comStatus = item.comStatus;
      var srvySqno = item.srvySqno;

      if(status=='ing' && comStatus =='non') {
        this.$router.push({ name: "survey-view", query: { srvySqno: srvySqno}}).catch(function() {});
      }
      else if(status=='fin' && comStatus =='non') {
        //미참여
      }
      else {
        this.$router.push({ name: "survey-view", query: { srvySqno: srvySqno}}).catch(function() {});
        //참여완료
      }
		},
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  }

};


</script>
